import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Breadcrumbs,
    Link as MLink,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Container,
    Button,
} from "@mui/material";

import { Link, useLocation } from "react-router-dom";

import "../../App.css";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { axiosInstance } from "../../Api/Axios/axios";
import { endpoints } from "../../Api/EndPoints/endpoints";
import EnquiryForm from "../HotDipGalvanization/Components/EnquiryForm";

const ProductPortfolioTlt = () => {
    const [data, setData] = useState([]);
    const [openEnquiry, setOpenEnquiry] = useState(false);

    const location = useLocation();

    const fetchData = async () => {
        try {
            const res = await axiosInstance.get(
                endpoints.TowerLineTransmission
                    .towerLineTransmissionCapabilities
            );

            setData(res?.data?.data || []);
        } catch (err) {
            console.log(err);
            setData([]);
        }
    };

    useEffect(() => {
        fetchData();

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    /*
     * URL theke current category slug ber kora
     *
     * Example:
     * /products/towerline-transmission/product-portfolio
     *
     * => product-portfolio
     */
    const currentSlug = location.pathname
        .split("/")
        .filter(Boolean)
        .pop();

    /*
     * API data theke current category ber kora
     */
    const currentCategory =
        data.find(
            (item) => item.category_title_slug === currentSlug
        ) || null;

    /*
     * Current category-r FAQ data
     *
     * Backend structure:
     *
     * faq: [
     *   {
     *      faq_image,
     *      question,
     *      answer
     *   }
     * ]
     */
    const faqData = Array.isArray(currentCategory?.faq)
        ? currentCategory.faq
        : [];

    return (
        <Box sx={{ padding: { xs: 2, md: 4 }, mt: "100px" }}>
            <Container maxWidth="xl">

                {/* Breadcrumb */}
                <Breadcrumbs sx={{ mb: 2, fontSize: "15px" }}>
                    <MLink
                        component={Link}
                        to="/home"
                        underline="hover"
                        color="inherit"
                    >
                        Home
                    </MLink>

                    <Typography
                        color="inherit"
                        sx={{ fontSize: "15px" }}
                    >
                        Product & Services
                    </Typography>

                    <Typography
                        color="text.primary"
                        sx={{ fontSize: "15px" }}
                    >
                        Tower Line Transmission
                    </Typography>

                    {currentCategory?.category_title && (
                        <Typography
                            color="text.primary"
                            sx={{ fontSize: "15px" }}
                        >
                            {currentCategory.category_title}
                        </Typography>
                    )}
                </Breadcrumbs>

                <Grid container spacing={3}>

                    {/* =========================
                        LEFT SIDEBAR
                    ========================== */}
                    <Grid
                        item
                        size={{ xs: 12, md: 3 }}
                        sx={{ mt: 2 }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "15px",
                                mb: 2,
                                textTransform: "uppercase",
                                fontFamily: "Roboto",
                            }}
                        >
                            Product & Services
                        </Typography>

                        <List sx={{ border: "1px solid #ddd" }}>

                            {/*
                             * Left menu API-r category_title
                             * theke automatically generate hobe
                             */}
                            {data.map((category) => {
                                const isActive =
                                    category.category_title_slug ===
                                    currentCategory?.category_title_slug;

                                return (
                                    <ListItemButton
                                        key={category.id}
                                        component={Link}
                                        to={`/products/towerline-transmission/${category.category_title_slug}`}
                                        sx={{
                                            borderBottom:
                                                "1px solid #eee",

                                            background: isActive
                                                ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                : "transparent",

                                            color: isActive
                                                ? "#fff"
                                                : "#000",

                                            "&:hover": {
                                                background: isActive
                                                    ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                    : "#f5f5f5",
                                            },

                                            fontFamily: "Roboto",
                                        }}
                                    >
                                        <ListItemText
                                            primary={
                                                category.category_title
                                            }
                                            primaryTypographyProps={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                fontFamily: "Roboto",
                                            }}
                                        />
                                    </ListItemButton>
                                );
                            })}

                        </List>

                        {/* Enquiry Button */}
                        <Box sx={{ mt: 4 }}>
                            <Button
                                variant="contained"
                                sx={{
                                    padding: "8px 15px!important",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    fontFamily: "Roboto",

                                    background:
                                        "linear-gradient(125deg, #b92d14, #1171b0)",

                                    boxShadow: "none",

                                    "&:hover": {
                                        background:
                                            "linear-gradient(125deg, #b92d14, #1171b0)",
                                        boxShadow: "none",
                                    },
                                }}
                                fullWidth
                                onClick={() =>
                                    setOpenEnquiry(true)
                                }
                            >
                                Enquiry Form
                            </Button>
                        </Box>
                    </Grid>

                    {/* =========================
                        RIGHT CONTENT
                    ========================== */}
                    <Grid
                        item
                        size={{ xs: 12, md: 9 }}
                        sx={{ mt: 3 }}
                    >

                        {/*
                         * IMPORTANT:
                         *
                         * Ekhane kono static Accordion nei.
                         *
                         * Backend-e faq data thaklei
                         * Accordion generate hobe.
                         *
                         * faq empty hole kichui show hobe na.
                         */}

                        {faqData.length > 0 &&
                            faqData.map((faq, index) => {

                                /*
                                 * Completely empty FAQ object
                                 * hole Accordion show korbe na.
                                 */
                                if (
                                    !faq?.question &&
                                    !faq?.answer &&
                                    !faq?.faq_image
                                ) {
                                    return null;
                                }

                                return (
                                    <Accordion
                                        key={`${currentCategory?.id}-${index}`}
                                        sx={{
                                            background: "#fff",
                                            boxShadow:
                                                "0px 2px 8px rgba(0,0,0,0.10)",
                                            borderRadius: "8px",
                                            "&:before": {
                                                display: "none",
                                            },
                                            mt: 4,
                                        }}
                                    >

                                        {/* Accordion Question */}
                                        <AccordionSummary
                                            expandIcon={
                                                <ExpandMoreIcon
                                                    sx={{
                                                        color: "#1A73E8",
                                                    }}
                                                />
                                            }
                                            sx={{
                                                backgroundColor:
                                                    "#f8f8f8",
                                                borderBottom:
                                                    "1px solid #eee",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: {
                                                        md: "20px",
                                                        xs: "16px",
                                                    },
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {faq.question}
                                            </Typography>
                                        </AccordionSummary>

                                        {/* Accordion Answer */}
                                        <AccordionDetails>
                                            <Box>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                >

                                                    {/* FAQ IMAGE */}
                                                    {faq?.faq_image && (
                                                        <Grid
                                                            item
                                                            size={{
                                                                xs: 12,
                                                                md: 4,
                                                            }}
                                                        >
                                                            <Box
                                                                component="img"
                                                                src={
                                                                    faq.faq_image
                                                                }
                                                                alt={
                                                                    faq.question ||
                                                                    "FAQ"
                                                                }
                                                                sx={{
                                                                    width:
                                                                        "100%",
                                                                    height:
                                                                        "auto",
                                                                    display:
                                                                        "block",
                                                                    borderRadius:
                                                                        "4px",
                                                                }}
                                                            />
                                                        </Grid>
                                                    )}

                                                    {/* FAQ ANSWER */}
                                                    <Grid
                                                        item
                                                        size={{
                                                            xs: 12,
                                                            md: faq?.faq_image
                                                                ? 8
                                                                : 12,
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize:
                                                                    "16px",
                                                                fontFamily:
                                                                    "Roboto",
                                                                textAlign:
                                                                    "justify",
                                                                mt: 0,
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    faq?.answer ||
                                                                    "",
                                                            }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Box>
                                        </AccordionDetails>

                                    </Accordion>
                                );
                            })}

                    </Grid>
                </Grid>
            </Container>

            <EnquiryForm
                open={openEnquiry}
                onClose={() => setOpenEnquiry(false)}
            />
        </Box>
    );
};

export default ProductPortfolioTlt;

